import React from 'react';
import * as s from './styled-var-encontradas';

const VariaveisEncontradas = () => {
  return (
    <s.Container className="style-container-aplicacao">
      <span>244</span>
      <h3>Variáveis encontradas</h3>
    </s.Container>
  );
};

export default VariaveisEncontradas;
